import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleRequest } from "../../helpers/handleAsync";
import shipService from "../../services/shipService";
import { IShipPayload } from "../../types/ship";

const calculateShippingPrice = createAsyncThunk(
    'discount/calculate',
    async (payload: IShipPayload) => {
        const [res, err] = await handleRequest(shipService.calculateShippingPrice(payload));
        if (!res || err) {
            throw new Error('Unknow error');
        }
        return res;
    }
)

export const shipPrvSliceActions = { calculateShippingPrice };